import React from 'react'
import "./footer.css"
import "../../App.css"

export default function Footer() {
    return (
        <footer id='FooterWrapper' className="d-flex flex-wrap justify-content-between align-items-center  border-top ">
            <span className=" mb-md-0 text-body-secondary text"> Made by Ayush Bahuguna</span>
            &nbsp;
            <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">

                <li className="ms-3  footerIcons">
                    <a rel="noopener noreferrer" className="text-body-secondary" target='_blank' href="https://www.linkedin.com/in/ayush-bahuguna-97baab223">
                        <i className="bi bi-linkedin icon"></i>
                    </a>
                </li>

                <li className="ms-3 footerIcons">
                    <a rel="noopener noreferrer" className="text-body-secondary" target='_blank' href="https://github.com/ayush735bahuguna">
                        <i className="bi bi-github icon"></i>
                    </a>
                </li>

                <li className="ms-3  footerIcons">
                    <a rel="noopener noreferrer" className="text-body-secondary" target='_blank' href="https://instagram.com/ayush.jsx?igshid=MzNlNGNkZWQ4Mg==">
                        <i className="bi bi-instagram icon"></i>
                    </a>
                </li>
            </ul>
        </footer>
    )

}
